<template>

    <div id="trailer" class="section">

      <div class="trailer_box">

          <div class="trailer_wrap">

          <div class="trailer_logo"><h1>Trailer</h1></div>
          <div class="trailer_inside_box">
  
              <iframe src="https://www.youtube.com/embed/zm3XfU9QD2k?si=QQDAcb0pwFTl5BCl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            
            </div> <!-- inside -->
  
          </div> <!--  wrap-->
  
      </div>

    </div>

  </template>
  
  <style>
  
  #trailer{
    /* border: 2px dashed rgb(7, 217, 108);  */
    position: relative;
    display: flex;
    font-family: 'Shippori Mincho', sans-serif;
    display: flex;
    height: 100svh;
    width:auto;
    min-height: 460px;
    justify-content: center;
  }
  
  .trailer_box{
    /* border: 2px solid rgb(24, 5, 194);  */
    position: relative;
    display: flex;
    text-align: left;
    padding: 0px;
    padding-top: 0vh;
    margin-top: 10vh;
    margin-bottom: 0vh;
    width:80vw;
    height:auto;
    justify-content: center;

  }
  
  .trailer_wrap{
    /* border: 2px solid rgb(24, 5, 194);  */
    position: relative;
    display:block;
    text-align: left;
    width:100%;
    height:auto;
    max-width: 768px;
    justify-content: center;


  }


  .trailer_logo{
    /* border: 2px solid rgb(194, 5, 74);  */
    position:relative;
    top:0%;
    padding-right: 0%;
    padding-left: 0;
    width:auto;
    height: auto;
    display: flex;
    justify-content:flex-start;
  }
  
  .trailer_logo h1{
    /* border: 2px solid rgb(5, 194, 43);  */
    top:0%;
    line-height: 1;
    letter-spacing: 0px; 
    font-weight: bolder;
    font-size:calc(32px);
    padding-left: 0vw;
  }
  
  
  .trailer_inside_box{
    position: relative;
    /* border: 2px solid rgb(5, 159, 194);  */
    width: 100%;
    height: 0;
    flex-wrap: wrap;
    margin-top: 2vh;
    align-items: center;
    justify-content: center;
    padding-top: 56.25%;
  }
  
  .trailer_inside_box iframe{
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height: 100%;
  }
  

  </style>